export default __webpack_public_path__ + "static/media/Success.e0040a52.svg";